import { logDispatcher } from 'src/app/core/decorators/state.decorators';
import { ServiceType } from '../models/service-type.model';

export namespace ServiceTypeActions {
  @logDispatcher
  export class GetServices {
    static readonly type = '[ServiceType] GetServices';
    constructor() {}
  }

  @logDispatcher
  export class GetServicesSuccess {
    static readonly type = '[ServiceType] GetServicesSuccess';
    constructor(public serviceTypes: ServiceType[]) {}
  }

  @logDispatcher
  export class GetServicesBySchool {
    static readonly type = '[ServiceType] GetServicesBySchool';
    constructor(public exerciseId: number, public schoolId: number) {}
  }

  @logDispatcher
  export class GetServicesBySchoolSuccess {
    static readonly type = '[ServiceType] GetServicesBySchoolSuccess';
    constructor(public serviceTypes: ServiceType[]) {}
  }

  @logDispatcher
  export class Error {
    static readonly type = '[ServiceType] Error';
    constructor(public error: any) {}
  }
}
